{
  "version": 1,
  "asset_id": "600ea7ad-5301-478f-86d1-42532e238461",
  "project_id": "01579873-aba5-45c2-b48e-0fe42afbbb35",
  "url": "/__l5e/assets-v1/600ea7ad-5301-478f-86d1-42532e238461/icon-mono.png",
  "r2_key": "a/v1/01579873-aba5-45c2-b48e-0fe42afbbb35/600ea7ad-5301-478f-86d1-42532e238461/icon-mono.png",
  "original_filename": "icon-mono.png",
  "size": 9899,
  "content_type": "image/png",
  "created_at": "2026-06-16T18:26:04Z"
}
